import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="not-found">
      <div className="font-heading text-gold text-7xl md:text-8xl mb-4">404</div>
      <div className="w-14 h-14 mx-auto border border-gold/40 flex items-center justify-center text-gold mb-8"><Compass size={24} /></div>
      <h1 className="font-heading text-3xl md:text-4xl text-white mb-4">This page took a detour</h1>
      <p className="text-gray-400 text-lg mb-10">The page you're looking for doesn't exist or may have moved. Let's get you back on track.</p>
      <div className="flex gap-4 justify-center flex-wrap">
        <Link to="/" data-testid="notfound-home" className="flex items-center gap-2 bg-gold text-navy px-8 py-4 font-semibold hover:bg-gold-light transition-colors">
          Back to home <ArrowRight size={16} />
        </Link>
        <Link to="/marketplace" className="border border-white/25 text-white px-8 py-4 hover:bg-white/5 transition-colors">Browse Designs</Link>
      </div>
    </div>
  );
}
